import { UseQueryResult, useQuery } from 'react-query'

import { isEmpty } from 'lodash'

import httpClient from 'services/http-client'

import { TEN_MINUTES_STALE_TIME } from 'constants/apis'

export const GET_BATCH_PRODUCTS_PRICES = '/products/prices'

type ProductPrices = {
  wholesalePrice: string | null
  msrp: string | null
  discountedPrice: string | null
}

export type ProductPricesInfos = {
  prices: ProductPrices
  key: string
}

type ProductPricesByProductId = Record<string, ProductPricesInfos>

const useBatchProductPrices = (
  skus: string[],
  lang: string,
  isLoggedIn: boolean
): UseQueryResult<ProductPricesByProductId> =>
  useQuery({
    enabled: !isEmpty(skus),
    queryKey: [GET_BATCH_PRODUCTS_PRICES, skus, lang, isLoggedIn],
    queryFn: async () => {
      const { data: skusPricingsByProductId } = await httpClient.post<ProductPricesByProductId>(
        `${GET_BATCH_PRODUCTS_PRICES}?ts=${Date.now()}`,
        {
          skus,
        }
      )

      return skusPricingsByProductId
    },
    staleTime: TEN_MINUTES_STALE_TIME,
  })

export default useBatchProductPrices
